import React from 'react';
import posthog from 'posthog-js';
import useSectionView from '../../hooks/useSectionView';

function Footer() {
  const sectionRef = useSectionView('section_viewed_footer');
  return (
    <footer ref={sectionRef} style={{ backgroundColor: 'var(--ink)', padding: '64px 24px' }}>
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
        <div className="ft-grid" style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gap: '48px',
          alignItems: 'start',
        }}>
          {/* Left — logo + tagline + social */}
          <div>
            <div style={{
              fontFamily: 'var(--font-serif)',
              fontSize: '24px',
              color: 'var(--on-signal)',
              marginBottom: '12px',
            }}>
              Tru<span style={{ color: 'var(--signal)' }}>Flow</span>
            </div>
            <p style={{
              fontFamily: 'var(--font-sans)',
              fontSize: '14px',
              color: 'var(--mute)',
              margin: '0 0 16px 0',
              lineHeight: 1.5,
            }}>
              The financial app for PDR.
            </p>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <a
                href="https://facebook.com/TruFlow"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TruFlow on Facebook"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'facebook' })}
                style={{ color: 'var(--mute)', display: 'flex', padding: '6px', margin: '-6px', transition: 'color 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--signal)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--mute)'; }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://instagram.com/gettruflow"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TruFlow on Instagram"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'instagram' })}
                style={{ color: 'var(--mute)', display: 'flex', padding: '6px', margin: '-6px', transition: 'color 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--signal)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--mute)'; }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
              <a
                href="https://tiktok.com/@gettruflow"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TruFlow on TikTok"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'tiktok' })}
                style={{ color: 'var(--mute)', display: 'flex', padding: '6px', margin: '-6px', transition: 'color 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--signal)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--mute)'; }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.84-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Middle — links */}
          <div>
            <p style={{
              fontFamily: 'var(--font-sans)',
              fontSize: '12px',
              fontWeight: 500,
              color: 'var(--mute)',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              margin: '0 0 16px 0',
            }}>
              Legal
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=479a6457-8426-4afa-a7b1-f879c691825d"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'terms' })}
                style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--bar-low)', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = 'var(--on-signal)'; }}
                onMouseLeave={e => { e.target.style.color = 'var(--bar-low)'; }}
              >
                Terms of Service
              </a>
              <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=cd80ded6-7249-43fa-935c-0093b03f9dde"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'privacy' })}
                style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--bar-low)', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = 'var(--on-signal)'; }}
                onMouseLeave={e => { e.target.style.color = 'var(--bar-low)'; }}
              >
                Privacy Policy
              </a>
              <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=8643b538-56b9-43a2-8f5e-62e7fb7f230f"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'cookie' })}
                style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--bar-low)', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = 'var(--on-signal)'; }}
                onMouseLeave={e => { e.target.style.color = 'var(--bar-low)'; }}
              >
                Cookie Policy
              </a>
              <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=9b4eba9c-71b4-41bd-b5cf-5c6b87a7e19e"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'disclaimer' })}
                style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--bar-low)', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = 'var(--on-signal)'; }}
                onMouseLeave={e => { e.target.style.color = 'var(--bar-low)'; }}
              >
                Disclaimer
              </a>
              <a href="mailto:support@gettruflow.com"
                onClick={() => posthog.capture('footer_link_clicked', { link: 'support' })}
                style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', color: 'var(--bar-low)', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = 'var(--on-signal)'; }}
                onMouseLeave={e => { e.target.style.color = 'var(--bar-low)'; }}
              >
                Support
              </a>
            </div>
          </div>

          {/* Right — copyright */}
          <div>
            <p style={{
              fontFamily: 'var(--font-sans)',
              fontSize: '14px',
              color: 'var(--mute)',
              margin: '0 0 8px 0',
              lineHeight: 1.5,
            }}>
              © 2026 TruFlow Technologies Inc.
            </p>
            <p style={{
              fontFamily: 'var(--font-sans)',
              fontSize: '13px',
              color: 'var(--slate)',
              margin: 0,
            }}>
              Built in Denver, Colorado.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .ft-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
